<ng-container *ngIf="title">
  <div class="d-flex align-items-center">
    <h1 class="flex-grow-1" *scText="rendering.fields.title"></h1>
    <div sc-placeholder name="ab-page-title" [rendering]="rendering"></div>
  </div>
</ng-container>

<ng-container *ngIf="description">
  <p *scRichText="rendering.fields.description"></p>
</ng-container>
